import { connect } from 'react-redux';
import { UserSettings } from '@leverege/ui-redux';
import { useEffect } from 'react';
import { GroupedTextFilterModel } from '@leverege/molten/screens';
import { FilterSourceModel } from '@leverege/molten/filters';
import { Config } from '@leverege/plugin';
import queryString from 'query-string';
function VinHiddenGroupScreen(props) {
  const {
    location,
    filterModel,
    objectType,
    filter,
    filterName,
    onFilterChange
  } = props;
  const onSearchChange = ({
    vins,
    filters,
    startDate,
    endDate,
    voidedTimestampStartDate,
    voidedTimestampEndDate,
    priorLostStartDate,
    priorLostEndDate
  }) => {
    let model, newFilter;
    if (vins) {
      model = GroupedTextFilterModel.toImagineFilter(filterModel, objectType);
      newFilter = FilterSourceModel.setFilter(filter, vins ? {
        ...model,
        value: vins
      } : null);
      newFilter = FilterSourceModel.setMetadata(newFilter, {
        value: vins
      });
    } else {
      const conditions = [];
      Object.keys(filters).forEach(key => {
        if (filters[key] === undefined) {
          return;
        }
        if (!filters[key]?.type) {
          conditions.push({
            type: 'equals',
            field: `data/${key}`,
            value: filters[key],
            fieldType: 'string',
            empty: false
          });
        } else {
          conditions.push(filters[key]);
        }
      });
      const model = {
        operator: 'and',
        type: 'logical',
        conditions: [...conditions, ...(startDate ? [{
          type: 'comparison',
          field: 'data/date',
          value: startDate,
          comparator: '>',
          isDate: true
        }] : []), ...(endDate ? [{
          type: 'comparison',
          field: 'data/date',
          value: endDate,
          comparator: '<',
          isDate: true
        }] : [])]
      };
      if (model?.conditions?.length) {
        newFilter = FilterSourceModel.setFilter(filter, model);
      }
    }
    if (newFilter !== filter && newFilter != null) {
      onFilterChange({
        data: filterName,
        value: newFilter,
        isOnMount: true
      });
    }
  };
  useEffect(() => {
    const {
      vins,
      state,
      businessState,
      type,
      startDate,
      endDate,
      foundTimestamp,
      driveOffTimestamp,
      voidedTimestamp,
      preRecBusinessState,
      [`${Config.get('VoidSale', 'saleLocationParentPath', 'location')}/id`]: saleLocationId,
      'location/id': locationId,
      id
    } = queryString.parse(location.search, {
      arrayFormat: 'comma'
    });
    const foundFilter = toRangeFilter(foundTimestamp, 'data/lost/foundTimestamp');
    const driveOffFilter = toRangeFilter(driveOffTimestamp, 'data/lost/driveOffTimestamp');
    const voidedFilter = toRangeFilter(voidedTimestamp, 'data/voidedTimestamp');
    const search = {
      ...(vins && {
        vins,
        startDate,
        endDate
      }),
      filters: {
        state,
        type,
        ...(businessState && (objectType === 'sale' ? {
          'locator/status': businessState
        } : {
          businessState
        })),
        foundTimestamp: foundFilter,
        driveOffTimestamp: driveOffFilter,
        voidedTimestamp: voidedFilter,
        preRecBusinessState,
        [`${Config.get('VoidSale', 'saleLocationParentPath', 'location')}/id`]: saleLocationId,
        'location/id': locationId,
        id: id ? {
          type: 'equals',
          field: 'id',
          value: id,
          fieldType: 'string',
          empty: false
        } : undefined
      },
      startDate,
      endDate
    };
    onSearchChange(search);
  }, [location.pathname]);
  return null;
}
function toRangeFilter(range, field, isDate = true) {
  if (range === undefined) {
    return undefined;
  }
  if (!Array.isArray(range) || range[0] == null && range[1] == null) {
    console.warn('invalid range filter array', range);
  }
  let filter;
  if (range[0] == null || !range[0]) {
    filter = {
      type: 'comparison',
      field,
      value: range[1],
      comparator: '<',
      isDate
    };
  } else if (range[1] == null || !range[1]) {
    filter = {
      type: 'comparison',
      field,
      value: range[0],
      comparator: '>',
      isDate
    };
  } else {
    filter = {
      type: 'comparison',
      field,
      value1: range[0],
      value2: range[1],
      comparator: '()',
      isDate
    };
  }
  if (range[2] === 'not') {
    filter.not = true;
  }
  return filter;
}
export default connect((state, props) => ({
  filterModel: UserSettings.get(state, props.settingsPath, {
    returnPromise: false
  })
}))(VinHiddenGroupScreen);